import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import useThemeRender from "../../theme/useThemeRender";
import {
  Typography,
  Box,
  TextField,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
// import {
//   setAppoveModal,
//   setFetchPending,
// } from "../../../../slices/invitationSlice";
// import PropTypes from "prop-types";
// import { BASE_URL } from "../../../../constant/apiUrl";
// import { patchAPI } from "../../../../API/ApiService";
// import {
//   showErrorToast,
//   showSuccessToast,
// } from "../../../../utils/Toast/toast";
import Loading from "../Loader";
import { darkTheme } from "../../theme/Theme";
import CloseIcon from "@mui/icons-material/Close";
import {
  StyledTypography,
  StyledTypography2,
  StyledBox,
} from "./CommonModalStyle";

export default function CommonModal({
  showIcon = false,
  isDeny,
  approveModal,
  denyhandler,
  handleClose,
  setExplanation,
  explanation,
  loading,
}) {
  const isDarkTheme = useSelector((state) => state.theme);

  const { flagUser } = useSelector((store) => store.user);

  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Dialog
      open={approveModal}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: "8px",
          border: `10px solid  ${useThemeRender("borderColorLayer3")}`,
          background: useThemeRender("cardBackgroundColorLayer1"),
          boxShadow: "0px 2px 24px 8px rgba(0, 92, 188, 0.12)",
          padding: isMobile ? "20px" : "32px",
          width: isMobile ? "100%" : "500px",
        },
      }}
    >
      {showIcon && (
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
      )}
      <DialogContent
        sx={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {loading && <Loading />}
        <Typography
          sx={{
            color: isDarkTheme ? "#fff" : "var(--Tokens-Text-Primary, #3A3A3A)",
            textAlign: "left",
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
            fontSize: "var(--Font-Size-H5, 24px)",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "var(--Line-Height-H5, 32px)",
          }}
        >
          {isDeny ? "Deny" : "Approver details "}
        </Typography>
        {isDeny && (
          <Typography
            sx={{
              color: isDarkTheme
                ? "#fff"
                : "var(--Tokens-Text-Primary, #3A3A3A)",
              textAlign: "left",
              fontFeatureSettings: "'liga' off, 'clig' off",
              fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
              fontSize: "var(--Font-Size-H5, 16px)",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "var(--Line-Height-H5, 20px)",
            }}
          >
            Please explain the reason of the denial
          </Typography>
        )}
        <StyledBox>
          <StyledTypography>Name</StyledTypography>
          <StyledTypography2>
            {flagUser?.firstName} {flagUser?.lastName}
          </StyledTypography2>
        </StyledBox>
        <StyledBox>
          <StyledTypography>Date</StyledTypography>
          <StyledTypography2>
            {new Date()
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
              .replace(/ /g, "-")}
          </StyledTypography2>
        </StyledBox>
        {isDeny && (
          <Box
            sx={{
              display: "flex",
              width: "full",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "8px",
            }}
          >
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 400,
                color: isDarkTheme ? "#fff" : "#000",
                fontFamily: "var(--Typography-Font-Family-Body, Inter)",
              }}
            >
              Explanation
            </Typography>

            <TextField
              placeholder="Type here"
              multiline
              minRows={4} // Controls the initial height
              maxRows={8}
              value={explanation}
              onChange={(e) => setExplanation(e.target.value)}
              error={explanation.length > 500}
              style={{
                width: "100%",
                color: isDarkTheme ? "#fff" : darkTheme.textColorLayer1,
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&.Mui-error fieldset": {
                    borderColor: "#D40020",
                    borderWidth: "1px",
                  },
                  "&:hover fieldset": {
                    borderColor: explanation.length > 500 ? "#D40020" : undefined,
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: explanation.length > 500 ? "#D40020" : undefined,
                    borderWidth: explanation.length > 500 ? "2px" : "1px",
                  },
                },
              }}
              variant="outlined"
              size="small"
              helperText={`${explanation.length}/500 characters`}
              slotProps={{
                formHelperText: {
                  sx: {
                    textAlign: "right",
                    marginLeft: 0,
                    marginRight: 0,
                    color: explanation.length > 500 
                      ? "#D40020" 
                      : isDarkTheme ? "#fff" : "#666",
                  },
                },
              }}
            />
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: "flex-end" }}>
        <Button
          variant="outlined"
          sx={{
            textTransform: "none",
            font: "bold",
            fontWeight: 700,
            borderRadius: "24px",
            "&:hover": {
              background: "#004B9A",
            },
            marginRight: "10px",
          }}
          onClick={handleClose}
        >
          Cancel
        </Button>
        {!isDeny && (
          <Button
            onClick={() => denyhandler("approve")}
            variant="contained"
            data-testid="approve-button"
            sx={{
              font: "bold",
              fontWeight: 700,
              textTransform: "none",
              borderRadius: "24px",
              backgroundColor: "#005CBC",
              fontFamily: "var(--Typography-Font-Family-Body, Inter)",
              lineHeight: "var(--Line-Height-Small, 20px)",
            }}
          >
            Approve
          </Button>
        )}
        {isDeny && (
          <Button
            onClick={() => denyhandler("deny")}
            disabled={explanation === "" || explanation.length > 500}
            variant="contained"
            data-testid="deny-button"
            sx={{
              font: "bold",
              fontWeight: 700,
              textTransform: "none",
              borderRadius: "24px",
              backgroundColor: "#005CBC",
              fontFamily: "var(--Typography-Font-Family-Body, Inter)",
              lineHeight: "var(--Line-Height-Small, 20px)",
            }}
          >
            Deny
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
